
































import PartnerCreateRequirementsList from "@/components/partner/PartnerCreateRequirementsList.vue";
import PartnerDetailImage from "@/components/partner/PartnerDetailImage.vue";
import { handleError } from "@/lib/utility/handleError";
import { Type } from "@/lib/utility/type";
import { PartnerUpdateEntity } from "@/models/partnerUpdateEntity";
import { MrfiktivCreatePartnerDtoGen } from "@/services/mrfiktiv/v1/data-contracts";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    PartnerDetailImage,
    PartnerCreateRequirementsList
  }
})
export default class PartnerCreateOrUpdateSubmitCard extends Vue {
  @Prop()
  partnerDto!: MrfiktivCreatePartnerDtoGen | PartnerUpdateEntity | any;

  @Prop({ default: false })
  isUpdatePartner!: boolean;

  @Prop()
  isValid!: boolean;

  isLoading = false;

  async createPartner() {
    this.isLoading = true;

    try {
      const createdPartner = await PartnerModule.createPartner(this.partnerDto as MrfiktivCreatePartnerDtoGen);
      Vue.$toast.success(this.$t("components.partner.PartnerCreateOrUpdateSubmitCard.partnerCreateSuccess"));
      this.$emit("closeDialog", true);
      this.$router.push({ name: "PartnerDetailView", params: { partnerId: createdPartner._id } });
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoading = false;
    }
  }

  async updatePartner() {
    this.isLoading = true;

    try {
      const updatePartner = await PartnerModule.updatePartner({
        id: PartnerModule.partner._id,
        partnerUpdateEntity: this.partnerDto as PartnerUpdateEntity
      });
      Vue.$toast.success(this.$t("components.partner.PartnerCreateOrUpdateSubmitCard.partnerUpdateSuccess"));
      this.$emit("closeDialog", true);

      this.$router.push({ name: "PartnerDetailView", params: { partnerId: updatePartner._id } });
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoading = false;
    }
  }

  get isValidCreate() {
    return this.isValid && this.isValidGeneralInformation() && this.isValidCompanyUserName() && this.isValidSettings();
  }

  get isValidUpdate() {
    return this.isValidGeneralInformation() && this.isValidSettings();
  }

  get requirementList() {
    const reqs = [
      {
        test: this.isValidGeneralInformation(),
        text: this.$t("components.partner.PartnerCreateOrUpdateSubmitCard.requirementGeneralInfo")
      },
      {
        test: this.isValidSettings(),
        text: this.$t("components.partner.PartnerCreateOrUpdateGeneralInfos.footer.contactDataTitle")
      }
    ];
    return reqs;
  }

  isValidGeneralInformation() {
    return (
      !Type.isBlankString(this.partnerDto.companyName) &&
      !Type.isBlankString(this.partnerDto.contact.email) &&
      !Type.isBlankString(this.partnerDto.address.street) &&
      !Type.isBlankString(this.partnerDto.address.zip) &&
      !Type.isBlankString(this.partnerDto.address.city) &&
      !(this.partnerDto.address.geo.lat === 0) &&
      !(this.partnerDto.address.geo.lng === 0)
    );
  }

  isValidCompanyUserName() {
    return !Type.isBlankString(this.partnerDto.companyUsername);
  }

  isValidSettings() {
    return !Type.isBlankString(this.partnerDto.settings.contact.email);
  }

  validate() {
    this.$emit("validate");
  }
}
